<script lang="ts">
    import {PendingRose} from "../rose";
    import NavigationButton from "../shared/NavigationButton.svelte";
    import {createEventDispatcher, onDestroy} from "svelte";

    export let rose: PendingRose;

    const dispatch = createEventDispatcher();

    let timout;

    function delayedReload() {
        return setTimeout(() => {
            dispatch('triggerUpdate');
            timout = delayedReload();
        }, 30000);
    }

    timout = delayedReload();

    onDestroy(() => clearTimeout(timout));
</script>
<svelte:head>
    <title>Roses UPC - Cua</title>
</svelte:head>

<p>La teva rosa s’està generant i la rebràs al correu electrònic quan s'hagi creat.</p>
<p>La intel·ligència artificial (IA) requereix una gran potència de càlcul, per la qual cosa pot trigar una estona a
    generar la rosa. Actualment estàs en la posició:</p>
<h2>
    {rose.queuePosition}
</h2>
<p>Si et quedes en aquesta pàgina, podràs veure com avança la cua.</p>
<p>Un cop generada, podràs visualitzar la teva Rosa UPC aquí mateix.</p>
<p>Mentrestant, pots explorar la galeria per veure altres roses que s'han generat.</p>

<div class="row-buttons">
    <NavigationButton to="galeria" text="Anar a la Galeria"></NavigationButton>
    <NavigationButton to="informacio" text="Vols saber-ne més?"></NavigationButton>
</div>